<!-- List View -->
<div *ngIf="!Edit && !Add">
  <h2>Notifications</h2>
  <button (click)="openForm()">Add New</button>

  <table>
    <thead>
      <tr>
        <th>Title</th>
        <th>Status</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let notif of notifications; let i = index">
        <td>{{ notif.title }}</td>
        <td>{{ notif.status }}</td>
        <td>
          <button (click)="editNotification(i)">Edit</button>
          <button (click)="deleteNotification(i)">Delete</button>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Form View -->
<div *ngIf="Add">
  <h3>{{ editIndex !== null ? 'Edit Notification' : 'Add Notification' }}</h3>
  <form [formGroup]="form" (ngSubmit)="submitForm()">
    <div>
      <label>Title:</label>
      <input type="text" formControlName="title" required />
    </div>

    <div>
      <label>Status:</label>
      <select formControlName="status">
        <option value="active">Active</option>
        <option value="deactive">Deactive</option>
      </select>
    </div>

    <button type="submit">Save</button>
    <button type="button" (click)="cancelForm()">Cancel</button>
  </form>
</div>


<div *ngIf="Edit">
  <h3>{{ editIndex !== null ? 'Edit Notification' : 'Add Notification' }}</h3>
  <form [formGroup]="form" (ngSubmit)="UpdateForm()">
    <div>
      <label>Title:</label>
      <input type="text" formControlName="title" required />
    </div>

    <div>
      <label>Status:</label>
      <select formControlName="status">
        <option value="active">Active</option>
        <option value="deactive">Deactive</option>
      </select>
    </div>

    <button type="submit">Save</button>
    <button type="button" (click)="cancelForm()">Cancel</button>
  </form>
</div>
